import React from 'react';
import Wrp from '../../../hoc/Wrp/Wrp';
import Modal from "react-bootstrap/Modal";
import { withRouter } from 'react-router';
import moment from 'moment';
import {getDateFormat} from '../../../Utils/UserFunctions';
import DatePicker from 'react-datetime';

const CreateNew = (props) => {
	const curState = props.curState;
    const formFields = curState.charge_formfields;
	return (
		<Modal size="sm" show={props.modelOpen} onHide={props.toggleModel}>
            <Modal.Header>
                <h5 className="modal-title secondary_color pl-2"> Charge Details </h5>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className="col-12">
                        <div className="form-group">
                            <label> Name </label>
                            <input type="text" value={formFields.name} name="name" onChange={props.createChargeChangeHandler} className="form-control" />
                        </div>
                    </div>

                    <div className="col-12">
                        <div className="form-group">
                            <label> Charge Code </label>
                            <input type="text" value={formFields.charge_code} name="charge_code" onChange={props.createChargeChangeHandler} className="form-control" />
                        </div>
                    </div>
                </div>
            </Modal.Body>

            <Modal.Footer>
                
                    <a onClick={props.toggleModel} className="btn btn-cancel mr-2"> Cancel </a> 
                    <a onClick={props.saveChargeDetails} className="btn primary_bg"> Save </a> 
                 
            </Modal.Footer>
		</Modal>
	);
}

export default withRouter(CreateNew);